module.exports = __webpack_public_path__ + "static/media/ePosterCinema.b387fa77.jpg";